var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLifetimePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9474 0H5.05263C2.26214 0 0 2.26214 0 5.05263V26.9474C0 29.7379 2.26214 32 5.05263 32H26.9474C29.7379 32 32 29.7379 32 26.9474V5.05263C32 2.26214 29.7379 0 26.9474 0Z",
    fill: "url(#paint0_linear_2682_24237)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.9475 0C29.7391 0 32.0001 2.26105 32.0001 5.05263V17.6842C22.2317 17.6842 14.3159 9.76842 14.3159 0H26.9475Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 19.3684H10.9474C11.8779 19.3684 12.6316 20.1221 12.6316 21.0526V32H5.05263C2.26105 32 0 29.7389 0 26.9474V19.3684Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2682_24237",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D228D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifetimePlan);
export default __webpack_public_path__ + "static/media/LifetimePlan.cf3b99aa09b76f82d524db2557d298b0.svg";
export { ForwardRef as ReactComponent };